var map = {
	"./2018-03-04/whats-new.html": 2206,
	"./2018-04-12/whats-new.html": 2207,
	"./2018-04-24/whats-new.html": 2208,
	"./2018-05-23/whats-new.html": 2209,
	"./2018-05-31/whats-new.html": 2210,
	"./2018-07-04/whats-new.html": 2211,
	"./2018-07-19/whats-new.html": 2212,
	"./2018-11-20/whats-new.html": 2213,
	"./2019-04-04/whats-new.html": 2214,
	"./2020-01-21/whats-new.html": 2215,
	"./2020-07-18/whats-new.html": 2216,
	"./2021-06-10/whats-new.html": 2217,
	"./2021-07-26/whats-new.html": 2218,
	"./2021-08-26/whats-new.html": 2219,
	"./2021-12-07/whats-new.html": 2220,
	"./2022-06-03/whats-new.html": 2221,
	"./2022-09-08/whats-new.html": 2222,
	"./2023-01-01/whats-new.html": 2223,
	"./2023-06-14/whats-new.html": 2224,
	"./2024-10-31/whats-new.html": 2225,
	"./2024-12-12/whats-new.html": 2226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2205;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 2205
// module chunks = 0